import AntdCheckbox from 'antd/lib/checkbox';
import React        from 'react';

export type CheckboxProps = Omit<FieldProps, 'placeholder' | 'autofocus'> & {
	children?: React.ReactNode
};

const Checkbox = ({ value, onChange, ...props }: CheckboxProps) => {
	return (
		<AntdCheckbox
			{...props}
			value={value}
			checked={value as boolean}
			onChange={event => onChange?.(event.target.checked)}
		/>
	);
};

Checkbox.Group = AntdCheckbox.Group;

export default Checkbox;
